<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h1>Starguides, Layanan Pemandu Wisata Oleh Mahasiswa Indonesia di Luar Negeri</h1>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/191029/metrotv-selamat-pagi-indonesia-24-oktober-2019.png')"
            fluid
            @click="openLink"
          />
        </b-col>

        <b-col class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Terbentuk sejak tahun 2017 dan secara resmi berbadan hukum pada tahun 2019, Starguides menjadi penyedia layanan pemandu wisata berbasis website pertama yang ada di Indonesia. Berawal dari pengalamannya menjadi pemandu wisata di Paris, Prancis, Raden Rifki, CEO Starguides memulai bisnis ini dari nol pada saat dirinya bermukim disana.
          </p>
          <p class="mt-3 text-justify">
            &emsp;Menjadi pemandu wisata bagi warga Indonesia di negeri orang sangat menggiurkan dan dapat menambah penghasilan. Melihat peluang tersebut, Raden Rifki berkeinginan membuat sebuah wadah yang dapat membantu menambah penghasilan mitranya yang sebagian besar merupakan mahasiswa yang sedang menempuh pendidikan diluar negeri.
          </p>
          <p class="mt-3 text-justify" style="font-size: 14px;">
            <i>
              24 Oktober 2019<br>
              Selamat Pagi Indonesia, MetroTV<br>
              <a href="https://www.metrotvnews.com/play/kM6Czmjr-starguides-layanan-pemandu-wisata-oleh-mahasiswa-indonesia-di-luar-negeri">https://www.metrotvnews.com/play/kM6Czmjr-starguides-layanan-pemandu-wisata-oleh-mahasiswa-indonesia-di-luar-negeri</a>
            </i>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12">
          <h4>StarGuides, Layanan Pemandu Wisata Oleh Mahasiswa Indonesia di Luar Negeri</h4>
        </b-col>

        <b-col cols="12">
          <b-img
            :src="require('@/assets/img/articles/191029/metrotv-selamat-pagi-indonesia-24-oktober-2019.png')"
            fluid
            @click="openLink"
          />
        </b-col>

        <b-col class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Terbentuk sejak tahun 2017 dan secara resmi berbadan hukum pada tahun 2019, Starguides menjadi penyedia layanan pemandu wisata berbasis website pertama yang ada di Indonesia. Berawal dari pengalamannya menjadi pemandu wisata di Paris, Prancis, Raden Rifki, CEO Starguides memulai bisnis ini dari nol pada saat dirinya bermukim disana.
          </p>
          <p class="mt-3 text-justify">
            &emsp;Menjadi pemandu wisata bagi warga Indonesia di negeri orang sangat menggiurkan dan dapat menambah penghasilan. Melihat peluang tersebut, Raden Rifki berkeinginan membuat sebuah wadah yang dapat membantu menambah penghasilan mitranya yang sebagian besar merupakan mahasiswa yang sedang menempuh pendidikan diluar negeri.
          </p>
          <p class="mt-3 text-justify" style="font-size: 12px;">
            <i>
              24 Oktober 2019<br>
              Selamat Pagi Indonesia, MetroTV<br>
              <a href="https://www.metrotvnews.com/play/kM6Czmjr-starguides-layanan-pemandu-wisata-oleh-mahasiswa-indonesia-di-luar-negeri">https://www.metrotvnews.com/play/kM6Czmjr-starguides-layanan-pemandu-wisata-oleh-mahasiswa-indonesia-di-luar-negeri</a>
            </i>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Content_Article191029',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    openLink: function () {
      window.open('https://www.metrotvnews.com/play/kM6Czmjr-starguides-layanan-pemandu-wisata-oleh-mahasiswa-indonesia-di-luar-negeri', '_blank')
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.content-picture {
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Article191029.vue